/**
 * LocationPin visibility contracts (Figma UI Mobile vs Desktop).
 *
 * Chapter section-header pins appear on desktop only — UI Mobile omits them
 * from Introduction / State / Pressure / Response header bodies. Mid-section
 * prose-block pins (intro part2, threatened, enablers, conclusion, …) stay
 * visible at all breakpoints. Pass `mdOnly` on `<LocationPin>` for headers.
 */

/** DOM marker when `mdOnly` is set (tests / CSS hooks). */
export const LOCATION_PIN_MD_ONLY_ATTR = 'data-location-pin-md-only';
